import {Tooltip, Tabs} from 'antd';
import React, {useState} from 'react';
import '../../../css/cardPreview.css';
import {alarm_hint_tooltip_css as alarmHintTooltipCss} from "../../../utils/PublicConstant";
import Icon from '@ant-design/icons';
import alarmImg from  "../../../imagers/icon/alarm.png";
import {getCardDigitalMaintain} from "../../../utils/PublicMethodTsx";

interface CardData{
    param:any,
    realData:any,
}
const RailPreview: React.FC<CardData> = (cardData) => {
    const [data,setData] = useState([]);
    React.useEffect(() => {
        let newData = cardData.realData?.find((item:any) => item.id == cardData.param.id)?.data?.craneDataList??[];
        setData(newData ?? data);
    },[cardData.realData]);
    React.useEffect(() => {

    },[]);
    return (
        <>
            <div className={"preview-tabs-head"}>
                <Tabs defaultActiveKey="1" type="card" size={"middle"} tabBarStyle={{}}
                      items={[
                          {
                              label:<span className="preview-tabs-head-label">概况</span>,
                              key:"1",
                              children:<div className={"preview-tabs-content"} style={{overflowY:"auto",height:"450px"}}>
                                  <table className="table table-borderless">
                                      <tbody>
                                      {
                                          data.map((item:any)=>{
                                              return <>
                                                  <tr key={item.type}><td colSpan={4}>{item.craneName}</td></tr>
                                                  <tr>
                                                      <td width="25%">主起升</td>
                                                      <td width="25%">高度：{item.hstData?.distance??''}</td>
                                                      <td width="25%">速度：{item.hstData?.speed??''}</td>
                                                      <td width="25%">重量：{item.hstData?.weight??''}</td>
                                                  </tr>
                                                  <tr>
                                                      <td width="25%">运行效率</td>
                                                      <td width="25%">{item.operatingData?.operatingEff??''}</td>
                                                      <td width="25%">故障停车时间</td>
                                                      <td width="25%">{item.operatingData?.faultTime??''}</td>
                                                  </tr>
                                                  <tr>
                                                      <td colSpan={4} width="100%">平均无故障时间：{item.operatingData?.faultFreeTimeAvg??''}</td>
                                                  </tr>
                                                  <tr>
                                                      <td colSpan={3}>
                                                          <div style={{display:"flex",width:'260px'}} id={"alarmDiv"}>
                                                              <div style={{margin:"2px 20px 0px 0px"}}>故障提示：{item.alarmInfo?.fault}</div>
                                                              <div style={{overflow:"hidden",flex:"1"}}>
                                                                  <Tooltip title={item.alarmInfo?.state} color="#C9CACA" overlayInnerStyle={alarmHintTooltipCss} placement="bottom">
                                                                      <div className="alarm-hint-tooltip-content"><span className="cancel-bold">{item.alarmInfo?.state}</span></div>
                                                                  </Tooltip>
                                                              </div>
                                                              <div style={{margin:"0px 3px"}}>
                                                                  <Icon component={() => (<img src={alarmImg} style={{width:"13px",height:"13px",display:item.alarmInfo?.fault === '0-无故障'?"none":"block"}}/>)}/>
                                                              </div>
                                                          </div>
                                                      </td>
                                                      <td>
                                                          <div style={{display:"flex"}}>
                                                              <div>保养：</div>
                                                              <div className="preview-tabs-content-digital" style={{background:getCardDigitalMaintain(item.usageState)}}></div>
                                                          </div>
                                                      </td>
                                                  </tr>
                                              </>
                                          })
                                      }
                                      </tbody>
                                  </table>
                              </div>
                          }
                      ]}
                />
            </div>

        </>
    );
};

export default RailPreview;